import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

const useGetPlatformAppClientSecretMutation = createMutationHook(
  PlatformAppsApiClient.getPlatformAppClientSecret,
  {
    mutationKey: ['getPlatformAppClientSecret'],
  },
)

export const useGetPlatformAppClientSecret = () => {
  const { getPlatformAppClientSecretMutation } = useGetPlatformAppClientSecretMutation()

  return {
    getPlatformAppClientSecret: getPlatformAppClientSecretMutation.mutateAsync,
    isLoading: getPlatformAppClientSecretMutation.isLoading,
  }
}
